'use client';

import { Language, type LanguageValue } from '@paladin-monorepo/common';
import { useTranslation } from 'react-i18next';

import { useLanguage } from '@/hooks/useLanguage';
import { cn } from '@/lib/utils';

const options: LanguageValue[] = [Language.CS, Language.EN];

export const LanguageSwitcher = ({ className = '' }: { className?: string }) => {
  const { language, setLanguage } = useLanguage();
  const { t } = useTranslation(undefined, {
    keyPrefix: 'toggleLanguage',
  });

  return (
    <div className={cn('flex w-full gap-2', className)}>
      {options.map((option) => (
        <button
          key={option}
          aria-label={t('label', { language: option.toUpperCase() })}
          className={cn(
            'flex h-7 w-full min-w-8 items-center justify-center rounded border bg-background text-xs font-medium uppercase transition-colors hover:bg-muted',
            language === option ? 'ring-2 ring-ring' : '',
          )}
          onClick={() => void setLanguage(option)}
          type="button"
        >
          {option}
        </button>
      ))}
    </div>
  );
};

LanguageSwitcher.displayName = 'LanguageSwitcher';
